import { queries } from "lib/build/dashboards/ltx/queries";
import { Origin } from "lib/build/events";
import { HyperImmunised } from "lib/build/forms/ltx/patientCondition";

import { useLastEventByQuery } from "src/features/events";

export function useHyperImmunised(): {
	value: boolean;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<HyperImmunised>(queries.hyperImmunised);
	return event === undefined
		? { value: false }
		: {
				value: event.value === HyperImmunised.YES,
				timestamp: event.timestamp,
				origin: event.origin
			};
}
